import { RpgClientObject } from "./Object"; 

export class RpgClientEvent extends RpgClientObject {
    _type = 'event'
}   